import { render, staticRenderFns } from "./CessationReasonsView.vue?vue&type=template&id=3787b390"
import script from "./CessationReasonsView.vue?vue&type=script&lang=js"
export * from "./CessationReasonsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports